import { Box, styled } from "@mui/material";
import {
	type FunctionComponent,
	type PropsWithChildren,
	useEffect,
} from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const Layout = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

type Props = { title: string };

export const UnauthenticatedLayout: FunctionComponent<
	PropsWithChildren<Props>
> = (props) => {
	const { title, children } = props;

	const { t } = useResource();

	useEffect(() => {
		document.title = `${title} | ${t(Resources.Common.AppName)}`;
	}, [title, t]);

	return <Layout>{children}</Layout>;
};
